// Client-side function middleware that attaches the Supabase bearer token to
// serverFn RPCs. Intentionally replaces the generated `attachSupabaseAuth`:
// this version imports the Supabase client lazily so `@supabase/supabase-js`
// stays out of the main entry chunk (perf: ~40 kB gzip off first load).
import { createMiddleware } from "@tanstack/react-start";

export const attachSupabaseAuthLazy = createMiddleware({ type: "function" }).client(
  async ({ next }) => {
    try {
      const { supabase } = await import("@/integrations/supabase/client");
      const { data } = await supabase.auth.getSession();
      const token = data.session?.access_token;
      return next({
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
    } catch {
      return next();
    }
  },
);
